<template>
  <div class="container-fluid p-0">
    <nav
      class="navbar navbar-expand-xl navbar-dark bg-dashboard-dark-1 shadow-sm py-0"
    >
      <router-link class="navbar-brand order-0" to="/">
        <img src="@/assets/jkr-logo.png" class="logo" />
      </router-link>
      <button
        class="navbar-toggler ml-auto border-0 order-1"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <ul class="mb-0 pl-3 order-2 order-lg-3">
        <li class="nav-item" id="signout">
          <div class="dropdown">
            <button
              class="btn dropdown-toggle p-0"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img class="user" src="@/assets/user.jpg" />
            </button>
            <div
              class="dropdown-menu dropdown-menu-right p-0"
              aria-labelledby="dropdownMenuButton"
            >
              <div class="dropdown-item-text small text-muted p-2">
                {{ user && user.email }}
              </div>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <button
                v-if="userRole == 'Super Admin'"
                class="dropdown-item small text-white p-2"
                @click="goToUsers()"
              >
                <font-awesome-icon :icon="['fas', 'user-cog']" class="mr-2" />
                User list
              </button>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <button
                v-if="userRole == 'Super Admin'"
                class="dropdown-item small text-white p-2"
                @click="goToUserLogs()"
              >
                <font-awesome-icon :icon="['fas', 'user-cog']" class="mr-2" />
                User Access Logs
              </button>
              <router-link
                v-if="userRole == 'Super Admin'"
                class="dropdown-item small text-white p-2"
                :to="{ name: 'caseDeleteLogs' }"
              >
                <font-awesome-icon
                  :icon="['fas', 'calendar-times']"
                  class="mr-2"
                />
                Case Delete Logs
              </router-link>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <a
                :href="cmsUrl"
                target="_blank"
                class="dropdown-item text-light small p-2"
                v-if="user && user.isCmsUser"
              >
                <font-awesome-icon :icon="['fas', 'road']" class="mr-2" />
                Link to CMS
              </a>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <template v-if="manuals.length">
                <button
                  class="dropdown-item small text-white p-2"
                  @click="showManualsModal = true"
                >
                  <font-awesome-icon :icon="['fas', 'file-pdf']" class="mr-2" />
                  Manuals
                </button>
                <div
                  class="dropdown-divider border-top m-0"
                  style="border-color: #222222 !important"
                ></div>
              </template>
              <a
                href="https://apps.apple.com/us/app/ronda/id6444923451"
                target="_blank"
                class="dropdown-item text-light small p-2"
                v-if="user"
              >
                <font-awesome-icon
                  :icon="['fab', 'app-store-ios']"
                  class="mr-2"
                />
                iOS App Store
              </a>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <a
                href="https://play.google.com/store/apps/details?id=my.inference.infrasel.worker"
                target="_blank"
                class="dropdown-item text-light small p-2"
                v-if="user"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="mr-2"
                />
                Google Play Store
              </a>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <button
                class="dropdown-item small text-white p-2"
                @click="showPasswordModal = true"
              >
                <font-awesome-icon :icon="['fas', 'key']" class="mr-2" />
                Change Password
              </button>
              <div
                class="dropdown-divider border-top m-0"
                style="border-color: #222222 !important"
              ></div>
              <button
                class="dropdown-item text-danger p-2"
                @click.prevent="logout()"
              >
                <font-awesome-icon
                  :icon="['fas', 'sign-out-alt']"
                  class="mr-2"
                /><small>Sign Out</small>
              </button>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="collapse navbar-collapse order-3 order-lg-2"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mr-auto">
          <li
            v-for="route in routes.filter(
              (route) =>
                !route.meta.roleRestricted ||
                (user && !route.meta.roleRestricted.includes(user.role.name))
            )"
            :key="route.name"
            class="nav-item justify-content-start justify-content-lg-center"
            :class="{
              active:
                $route.path == '/upload'
                  ? route.name == 'cases'
                  : isActiveNav(route.name),
            }"
          >
            <router-link
              class="nav-link stretched-link"
              :to="{ name: route.name }"
            >
              <span v-if="route.icon">
                <font-awesome-icon :icon="route.icon" />
              </span>
              <span v-if="route.label">{{ route.label }}</span>
              <span class="text-capitalize" v-else>{{ route.name }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <slot />
    <change-password-modal
      :show="showPasswordModal"
      @close="showPasswordModal = false"
    />
    <manuals-modal
      :show="showManualsModal"
      :manuals="manuals"
      @close="showManualsModal = false"
    />
  </div>
</template>

<script>
import { routes } from "@/router/routes";
import ChangePasswordModal from "../modals/ChangePassword";
import ManualsModal from "../modals/ManualsModal";
import API from "@/api";

export default {
  components: {
    ChangePasswordModal,
    ManualsModal,
  },
  data() {
    return {
      user: null,
      userRole: null,
      manuals: [],
      showManualsModal: false,
      showPasswordModal: false,
      routes: routes.filter((route) => route.meta?.showInNavbar),
    };
  },
  computed: {
    cmsUrl() {
      return API.cmsUrl();
    },
  },
  methods: {
    goToUsers() {
      this.$router.push({
        name: "users",
      });
    },
    goToUserLogs() {
      this.$router.push({
        name: "logs",
      });
    },
    isActiveNav(name) {
      return this.$route.name == name;
    },
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.push({
        name: "auth",
      });
    },
    async getManuals() {
      try {
        const retVal = await API.get("manuals?active=true&_sort=order");
        this.manuals = retVal.data || [];
      } catch (err) {
        // Fail soft: leave the list empty so the dropdown simply omits the
        // Manuals button rather than breaking the rest of the menu.
        console.error("Failed to load manuals:", err);
        this.manuals = [];
      }
    },
  },
  mounted() {
    let _user = localStorage.getItem("user");

    if (_user) {
      this.user = JSON.parse(_user);
      this.userRole = JSON.parse(_user).role.name;
      this.getManuals();
    }
  },
};
</script>
